<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12">
    <h2 class="page-title" tabindex="0">{{'breadcrumb.edit-org-picture' | translate}}</h2>
    <div class="col-12 p-0 m-0 mb-2">
        <xng-breadcrumb separator=" > ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <span *ngIf="breadcrumb">
                    {{ 'breadcrumb.' + breadcrumb | translate }}
                </span>
            </ng-container>
        </xng-breadcrumb>
    </div>
    <div class="container">
        <div class="row justify-content-center">
            <img [src]="picturePreview ? picturePreview : 'assets/images/company.png'" class="img-round img-size" alt="Logo" />
        </div>
        <div class="row mt-3 justify-content-center">
            <div class="custom-file">
                <input type="file" class="custom-file-input" id="customFileLang" [lang]="lang" title="{{'account.upload_image' | translate}}"
                        (change)="handleLogoPictureUpload($event.target.files)">
                <div class="custom-file-label custom-label" id="fileLabel" title="{{'general.select' | translate}}"></div>
            </div>
        </div>
        <div class="row text-center mt-3">
            <div id="doc-err" class="col-12 error"></div>
        </div>
        <div class="row mt-3 justify-content-center">
            <button type="button" title="{{'general.update' | translate}}" class="btn btn-green btn-h-green btn-width" (click)="saveLogo()" [disabled]="!logoPicture">
                {{'general.update' | translate}}
            </button>
        </div>
        <div class="row mt-3 justify-content-center">
            <button type="button" title="{{'general.delete' | translate}}" class="btn btn-red btn-h-red btn-width" (click)="deleteLogo()" [disabled]="!logoExists">
                {{'general.delete' | translate}}
            </button>
        </div>
    </div>
</div>